import React, { PropsWithChildren } from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { ArrowBack } from '@material-ui/icons';
import {
  Box,
  IconButton,
  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import CurrentPlan from '../CurrentPlan';
import { fetchApi } from '../../../../redux/actions/fetch-actions';
import { APIMethods } from '../../../../types/fetch/fetch-types';
import { AxiosError, AxiosResponse } from 'axios';
import { IBillingDetail } from '../../interfaces/IBillingDetail';
import InvoiceHistory from '../InvoiceHistory';
import CancellationView from './CancellationView';
import { StyledDivider } from '../StyledDivider';
import { hide, show } from 'redux-modal';

const useStyles = makeStyles((theme: Theme) => ({
  info: {
    padding: '64px 64px 40px',
    backgroundColor: theme.palette.primary.main
  },
  billing: {
    padding: '64px 64px 40px'
  },
  currentPlan: {
    margin: '1rem'
  }
}));

const BillingView = (props: PropsWithChildren<any>) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [billingDetails, setBillingDetails] = React.useState<IBillingDetail>();
  const [cancellationPage, setCancellationPage] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorPage, setErrorPage] = React.useState({
    code: null
  });

  React.useEffect(() => {
    setLoading(true);
    dispatch(
      fetchApi({
        url: 'stripe/billing',
        method: APIMethods.GET
      })
    )
      .then((result: AxiosResponse) => {
        const { billing } = result.data;
        const { activePlan, invoices } = billing;
        setLoading(false);
        setBillingDetails({
          invoices,
          activePlan
        });
      })
      .catch((err: AxiosError) => {
        setLoading(false);
        dispatch(
          show('snackbar', {
            variant: 'error',
            message: 'error retriving billing details'
          })
        );
      });
  }, []);

  const goBack = () => {
    history.goBack();
  };

  const showCancellationPage = () => {
    setCancellationPage(true);
  };

  async function handleCancellation(
    subscriptionId: string,
    cancellationReason: string
  ) {
    dispatch(show('spinner', { text: 'cancelling subscription' }));
    try {
      const response = await dispatch(
        fetchApi({
          url: `stripe/billing/cancel/${subscriptionId}`,
          method: APIMethods.POST,
          data: {
            cancellationReason
          }
        })
      );
      const { activePlan }: any = response.data;
      dispatch(
        show('snackbar', {
          variant: 'success',
          message: 'Subscription cancelled'
        })
      );
      // @ts-ignore
      setBillingDetails({ activePlan, invoices: billingDetails?.invoices });
      setCancellationPage(false);
    } catch (err) {
      dispatch(
        show('snackbar', {
          variant: 'error',
          message: 'Error cancelling subscription'
        })
      );
    }
    dispatch(hide('spinner'));
  }

  return (
    <Grid container>
      <Grid className={classes.info} item xs={12} md={4}>
        <Typography variant={'h3'}>Shoelace Billing</Typography>
        <Box
          onClick={goBack}
          alignItems={'center'}
          style={{ cursor: 'pointer' }}
        >
          <IconButton>
            <ArrowBack />
          </IconButton>
          Go back to dashboard
        </Box>
      </Grid>
      <Grid className={classes.billing} item xs={12} md={8}>
        {cancellationPage && billingDetails?.activePlan ? (
          <CancellationView
            handleCancellation={handleCancellation}
            goBack={() => setCancellationPage(false)}
            activePlan={billingDetails.activePlan}
          />
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <h1>Billing</h1>
            </Grid>
            <Grid item xs={12}>
              <strong>Current Plan</strong>
              <StyledDivider />
              {loading ? (
                'loading'
              ) : (
                <CurrentPlan
                  plan={billingDetails?.activePlan}
                  handleCancel={showCancellationPage}
                />
              )}
            </Grid>
            {/*<Grid item xs={12}>*/}
            {/*  <span>Payment Method</span>*/}
            {/*  <StyledDivider />*/}
            {/*</Grid>*/}
            {/*<Grid item xs={12}>*/}
            {/*  <span>Billing information</span>*/}
            {/*  <StyledDivider />*/}
            {/*</Grid>*/}
            <Grid item xs={12}>
              <strong>Billing history</strong>
              <StyledDivider />
              {loading ? (
                'loading'
              ) : (
                <InvoiceHistory invoices={billingDetails?.invoices} />
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default BillingView;
